export default function  LibraryMeeting() {
    return (
        <div className="accordion-item">
        <h2 className="accordion-header">
          <button className="accordion-button caret-off collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseLibraryMeeting">
            <div className="custom-button-layout">
            <img className="day-icon" src="../img/cal-icons/october-14-icon.png" alt="October 14 Calendar Icon" />
            <b>Library Meeting<br/>Borough Hall Downstairs Conference Room
             </b>
             {/* <span className="badge bg-danger">CANCELED</span> */}
                  <span className="badge bg-primary badge-custom">Meeting</span> 
            </div>
          </button>
        </h2>
        <div id="collapseLibraryMeeting" className="accordion-collapse collapse" data-bs-parent="#upcomingEventsAccordion">
          <div className="accordion-body">
          <p>
            {/* 
            This meeting has been canceled.
            */}
            Wednesday, October 14, 2026 at 7:00 p.m.<br /> 
            <a href="https://maps.app.goo.gl/uB7NMgLow9j2wTka6">
              <i className="fa-solid fa-location-pin"></i>&nbsp;Morrisville Borough Hall (35 Union St.)<br/>DOWNSTAIRS CONFERENCE ROOM
            </a>
            
          </p>
          </div>
        </div>
      </div>
    )
}